import {
  NotificationPayload,
  NotificationResponse,
  SendMessagePayload,
} from './useNotifications.types';

import { useApi } from './useApi';
import { BaseRequest, BaseHookRequest } from './useApi.types';

export const useNotifications: BaseHookRequest<NotificationResponse[], NotificationPayload[]> =
  params => {
    const [{ getRequest }, state] = useApi<NotificationResponse[]>(params);
    const getNotifications: BaseRequest<NotificationResponse[]> = () =>
      getRequest<NotificationPayload>('/user/notification/all');

    return [getNotifications, state];
  };

export const useSendMessage: BaseHookRequest<undefined, SendMessagePayload> = params => {
  const [{ postRequest }, state] = useApi<undefined>(params);
  const inviteManager: BaseRequest<SendMessagePayload> = details =>
    postRequest<any>('/admin/message/send', details?.variables);
  return [inviteManager, state];
};
